const statuses = {
  ERROR: 'ERROR',
  SAVED: 'SAVED',
  SAVING: 'SAVING',
  UNSAVED: 'UNSAVED',
};

export default statuses;
